export default "__VITE_ASSET__67866b74__"